export const SET_SUBSCRIPTION = 'SET_SUBSCRIPTION';

export const setSubscription = (subscription) => ({
  type: SET_SUBSCRIPTION,
  payload: subscription,
});
